// extracted by mini-css-extract-plugin
module.exports = {"section":"video-hero-section_section__gonKK"};